<template lang="html">

  <section class="wrapper contacto">

    <div class="encabezado" data="contacto"></div>
    <nav class="migas">
      <div class="container row-start">
        <router-link to="/">Inicio</router-link>
        <router-link :to="$t('enlaces.contacto')">Contacto</router-link>
      </div>
    </nav>

    <div class="content">

      <h1>Podemos ayudarte</h1>

      <div class="texto-intro container">
        <p>Para cualquier solicitud de información referente a nuestros servicios, ya seas candidato o empresa, no dudes
          en contactar con nosotros a través de este formulario. Cuéntanos con el máximo detalle tu duda o solicitud.
          Nos pondremos en contacto a la mayor brevedad.</p>
        <p>Gracias por tu confianza.</p>
      </div>


      <formulario></formulario>

      <div class="texto-cita container">
        <h2>Pide cita con nuestro equipo.</h2>
        <p>Agencia de Colocación Centro San Valero</p>
        <p>Calle Violeta Parra 9, 50015, Zaragoza</p>
        <p><strong>Teléfono:</strong> <a href="tel:976466599">976.466.599</a></p>
        <p><strong>Horario de atención:</strong> lunes a viernes de 9:00 a 14:00</p>
        <a href="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3RdR9nYNdXx-DpNhlg3slR0zxklbvr9ChzDVD9D3rBk1FTbkyCcwwXnLbCiUE-CMTLZLtqCY3v" target="_blank" class="btn">
          Pide cita en agencia de colocación
        </a>
      </div>
    </div>
  </section>

</template>

<script lang="js">

import formulario from '@/components/view-parts/contacto/formulario'

export default {
  name: 'contacto',
  components: {
    formulario
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/contacto.vue